type ManifestEntry = {
  path: string
  entityParams: string[]
  description?: string
}

type Manifest = Record<string, ManifestEntry>

type Action = {
  entityKey: string
  entityData: Record<string, string>
}

export function resolveRouteFromManifest(
  manifest: Manifest,
  action: Action
): string {
  const entry = manifest[action.entityKey]
  if (!entry) return '/'

  let path = entry.path
  for (const param of entry.entityParams || []) {
    const value = action.entityData?.[param]
    if (!value) return '/'
    path = path.replace(`:${param}`, value)
  }

  return path
}
